/**
 * G0 Latin character set with the English national option sub-set
 * (ETSI EN 300 706 tables 35/36). Teletext codes are 7-bit; the positions
 * that differ from ASCII are listed here.
 */
const G0_ENGLISH: Record<number, string> = {
  0x23: '£',
  0x24: '$',
  0x40: '@',
  0x5b: '←',
  0x5c: '½',
  0x5d: '→',
  0x5e: '↑',
  0x5f: '#',
  0x60: '—',
  0x7b: '¼',
  0x7c: '‖',
  0x7d: '¾',
  0x7e: '÷',
  0x7f: '■',
};

const UNICODE_TO_G0 = new Map<string, number>();
for (let c = 0x20; c < 0x7f; c++) {
  const mapped = G0_ENGLISH[c];
  if (mapped === undefined) UNICODE_TO_G0.set(String.fromCharCode(c), c);
}
for (const [code, ch] of Object.entries(G0_ENGLISH)) UNICODE_TO_G0.set(ch, Number(code));
// Friendly aliases for characters editors will type or feeds will send.
UNICODE_TO_G0.set('–', 0x60); // en dash
UNICODE_TO_G0.set('―', 0x60); // horizontal bar
UNICODE_TO_G0.set('‐', 0x2d); // hyphen
UNICODE_TO_G0.set('‘', 0x27);
UNICODE_TO_G0.set('’', 0x27);
UNICODE_TO_G0.set('“', 0x22);
UNICODE_TO_G0.set('”', 0x22);
UNICODE_TO_G0.set(' ', 0x20);
UNICODE_TO_G0.set('…', 0x2e); // caller may expand to "..." first

/** Display character for a G0 code (spacing attributes render as a space). */
export function g0ToUnicode(code: number): string {
  const c = code & 0x7f;
  if (c < 0x20) return ' ';
  return G0_ENGLISH[c] ?? String.fromCharCode(c);
}

/**
 * G0 code for a Unicode character, or undefined when the character has no
 * Level 1 representation (the compiler substitutes and warns; Level 1.5
 * enhancements may carry accented Latin letters).
 */
export function unicodeToG0(ch: string): number | undefined {
  return UNICODE_TO_G0.get(ch);
}

/** True for codes that are mosaic characters when in mosaics mode (bit 6 set). */
export function isMosaicCode(code: number): boolean {
  return (code & 0x20) !== 0 && code >= 0x20;
}
